import React from "react";
import { Link } from "react-router-dom";
import { Compass, ArrowRight, Sparkles } from "lucide-react";

interface AvailableProjectsCardProps {
  data: {
    total: number;
    newThisWeek: number;
    topCategories: { name: string; count: number }[];
  };
  loading?: boolean;
}

const AvailableProjectsCard: React.FC<AvailableProjectsCardProps> = ({
  data,
  loading = false,
}) => {
  if (loading) {
    return (
      <div className="bg-white rounded-xl p-5 shadow-sm">
        <div className="animate-pulse space-y-4">
          <div className="h-5 bg-gray-200 rounded w-36"></div>
          <div className="h-16 bg-gray-200 rounded"></div>
          <div className="space-y-2">
            {[...Array(3)].map((_, i) => (
              <div key={i} className="h-4 bg-gray-200 rounded"></div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-xl p-5 shadow-sm">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <Compass className="w-5 h-5 text-indigo-600" />
          <h3 className="font-semibold text-gray-900">Available Projects</h3>
        </div>
        <Link
          to="/projects?tab=available"
          className="text-sm text-blue-600 hover:text-blue-700 flex items-center gap-1"
        >
          Browse <ArrowRight className="w-4 h-4" />
        </Link>
      </div>

      <div className="flex items-center justify-between p-4 bg-gradient-to-r from-indigo-50 to-purple-50 rounded-lg mb-4">
        <div>
          <p className="text-3xl font-bold text-indigo-600">{data.total}</p>
          <p className="text-sm text-gray-600">Open Projects</p>
        </div>
        {data.newThisWeek > 0 && (
          <div className="flex items-center gap-1 bg-green-100 text-green-700 px-3 py-1 rounded-full text-sm">
            <Sparkles className="w-4 h-4" />+{data.newThisWeek} this week
          </div>
        )}
      </div>

      {data.topCategories.length > 0 && (
        <div>
          <p className="text-xs text-gray-500 uppercase font-medium mb-2">
            Top Categories
          </p>
          <div className="space-y-2">
            {data.topCategories.slice(0, 3).map((cat) => (
              <div
                key={cat.name}
                className="flex items-center justify-between text-sm"
              >
                <span className="text-gray-700">{cat.name}</span>
                <span className="text-gray-500">{cat.count} projects</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default AvailableProjectsCard;
